var _path, _rect, _rect2, _rect3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgKanbanBoardIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.4809 51.3404H3.84863C1.71891 51.3404 0 49.6103 0 47.4909V3.84945C0 1.71927 1.71891 0 3.84863 0H47.4917C49.6106 0 51.3404 1.71927 51.3404 3.84945V47.5017C51.3295 49.6103 49.5998 51.3404 47.4809 51.3404ZM3.84863 1.0813C2.32432 1.0813 1.08108 2.32481 1.08108 3.84945V47.5017C1.08108 49.0264 2.32432 50.2699 3.84863 50.2699H47.4917C49.016 50.2699 50.2593 49.0264 50.2593 47.5017V3.84945C50.2593 2.32481 49.016 1.0813 47.4917 1.0813H3.84863Z",
    fill: "#B3B3B3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19.6641,
    y: 4.36914,
    width: 12.0158,
    height: 25.0863,
    rx: 2,
    fill: "#3B82C9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 34.957,
    y: 4.36914,
    width: 12.0158,
    height: 13.9369,
    rx: 2,
    fill: "#8CBFFF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 4.37109,
    y: 4.36914,
    width: 12.0158,
    height: 40.4169,
    rx: 2,
    fill: "#2B6299"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKanbanBoardIcon);
export default __webpack_public_path__ + "static/media/kanban_board_icon.efd63c8b.svg";
export { ForwardRef as ReactComponent };